import { AsyncThunk, AsyncThunkConfig, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchByIdFactory } from "./fetchByIdFactory";
import { GET_STATION, Station, StationResponse } from "../../Services/Agrisys_GqlDataCaller/StationCalls/queryStations";


export const fetchStationByIdsThunk = createAsyncThunk(
  `station/fetchByIds`,
  fetchByIdFactory<StationResponse, Station>(GET_STATION, (stationResponse) => stationResponse.data.station.info.stations)
) satisfies AsyncThunk<Station[], number[], AsyncThunkConfig> as AsyncThunk<Station[], number[], AsyncThunkConfig>